// Initial state 
const state = {
    notificationsCounter:0,
    notificattions: []
};

// Update Data "mutations"
const mutations = {
    setNotificattions(state, value) {
        state.notificattions = value
    },
    setNotificationsCounter(state, value) {
        state.notificationsCounter = value
    },
};
// Get data
const getters = {
    geNotificattions: state => {
        return state.notificattions;
    },
    getNotificationsCounter: state => {
        return state.notificationsCounter;
    },
};

export default {
    mutations,
    state,
    getters
};